import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';
import { useMemo } from "react";

const FormSelect = ({ options, value, onChange, creatable, classNamePrefix, isMulti, placeholder, title, isDisabled }) => {
  const CustomSelect = useMemo(
    () => (creatable ? CreatableSelect : Select),
    [creatable]
  );
  return (
    <>
      <CustomSelect
        options={options}
        value={value}
        onChange={(val) => onChange?.(val)}
        classNamePrefix={classNamePrefix}
        isClearable
        isSearchable
        menuPosition="fixed"
        isMulti={isMulti}
        placeholder={placeholder}
        isDisabled={isDisabled}
      />
      {!isDisabled && <label className="select__label">{title}</label>}
    </>
  );
};

export default FormSelect;
